export const weekRanges2026 = [
    {"Week": 1, "start":"2026:8:9", "end":"2026:8:15"},
    {"Week": 2, "start":"2026:8:16", "end":"2026:8:22"},
    {"Week": 3, "start":"2026:8:23", "end":"2026:8:29"},
    {"Week": 4, "start":"2026:8:30", "end":"2026:9:6"},
    {"Week": 5, "start":"2026:9:7", "end":"2026:9:13"},
    {"Week": 6, "start":"2026:9:14", "end":"2026:9:20"},
    {"Week": 7, "start":"2026:9:21", "end":"2026:9:27"},
    {"Week": 8, "start":"2026:9:28", "end":"2026:10:3"},
    {"Week": 9, "start":"2026:10:4", "end":"2026:10:10"},
    {"Week": 10, "start":"2026:10:11", "end":"2026:10:17"},
    {"Week": 11, "start":"2026:10:18", "end":"2026:10:24"},
    {"Week": 12, "start":"2026:10:25", "end":"2026:11:1"},
    {"Week": 13, "start":"2026:11:2", "end":"2026:11:8"},
    {"Week": 14, "start":"2026:11:9", "end":"2026:11:15"},
    {"Week": 15, "start":"2026:11:16", "end":"2026:11:22"},
    {"Week": 16, "start":"2026:11:23", "end":"2026:11:29"},
    {"Week": 17, "start":"2026:11:30", "end":"2027:0:5"}
]

export const currentYear = 2026

